<template>
  <div>
    <!-- SideBar -->
    <aside id="hideScroll" class="menu app-sidebar animated unselect"
           :class="`slide${show ? 'In' : 'Out'}Left`"
           :style="`top:${isBuilder ? '0' : '50px'};height: calc(100% - ${isBuilder ? '0' : '50px'});`">

      <!-- 사이트 바로가기 / 디자인 편집 -->
      <div class="button-site-wrapper"
           v-if="!isLaunchpack && !isBuilder && $store.getters.mode === 'admin'">
        <a :href="serviceDomain" target="_blank">
          <div class="button-site">
            <img class="svg-sub" :src="svgSrc('u_external-link-alt')"/>
            <div class="size-13">사이트 바로가기</div>
          </div>
        </a>

        <!--<div class="button-site-primary" @click="openLink(1)">
          <img :src="svgSrc('u_edit')"/>
          <div class="size-13">디자인 편집</div>
        </div>-->
      </div>

      <ul class="menu-list">
        <!-- 대시보드 -->
        <!--<a v-if="dashboard" class="menu-item" :class="menuItemClass(dashboard)" @click="selectMenu(dashboard)">
          <img v-if="hasImg(dashboard)" :class="menuItemImg(dashboard)" :src="src(dashboard)">
          <div class="menu-name">{{ dashboard.name }}</div>
        </a>-->
        <template v-if="isAdmin && !isLaunchpack">
          <li v-for="(item, idx) in menu_set.lp_admin_menu" :key="`lp-admin-menu-${idx}`">
            <a class="menu-item" :class="menuItemClass(item)" @click="selectLpMenu(item)">
              <img  v-if="hasImg(item)" :class="menuItemImg(item)" :src="src(item)">
              <div v-if="item.name === '앱마켓' && serviceInfo && serviceInfo.plan && serviceInfo.plan.trial">
                <span class="menu-name" style="flex:0">{{ item.name }}</span>
                <span class="tag-trial">무료체험</span>
              </div>
              <div v-else class="menu-name">{{ item.name }}</div>
              <i v-if="!item.path"
                 class="material-icons lp-menu-item-arrow">keyboard_arrow_{{ item.selected ? 'up': 'down' }}</i>
            </a>
            <!-- 2차 -->
            <ul style="margin:0;padding-left:0">
              <li v-for="child in item.child" :key="child.id"
                  v-show="item.selected && visible(child)">
                <a @click.capture.prevent="selectLpMenu(child)"
                   :style="menuColorStyle(child.child)"
                   :href="child.path"
                   :class="{'menu-selected':selection(child.path)}"
                   class="menu-hover depth2">
                  <span>{{ child.name }}</span>
                </a>
              </li>
            </ul>
          </li>
        </template>

        <div v-for="(cm,c_idx) in computedMenu" :key="`cm-${c_idx}`">
          <!-- 메뉴 제목 -->
          <div v-if="!cm.market && !cm.inquiry"
            class="menu-title-wrapper">
            <div class="menu-title">{{ cm.title }}</div>
            <div class="menu-title-solid"></div>
          </div>
          <div v-else
               class="menu-title-foldable-wrapper" @click="cm.expand = !cm.expand">
            <img :src="svgSrc('ic_crown')" alt="crown">
            <div class="menu-title">{{ cm.title }}</div>
            <div class="menu-title-solid"></div>
            <i class="menu-arrow material-icons">keyboard_arrow_{{ cm.expand ? 'up' : 'down' }}</i>
          </div>

          <!-- 1차 -->
          <div v-show="cm.expand || (!cm.market && !cm.inquiry)" style="position: relative" :ref="`item${c_idx}`">
            <li v-for="(item, idx) in cm.menu" v-show="visible(item)" :key="`menu-${idx}`">
              <a class="menu-item" :class="menuItemClass(item)" @click="selectMenu(item)">
                <img  v-if="hasImg(item)" :class="menuItemImg(item)" :src="src(item)">
                <div class="menu-name">{{ item.name }}</div>
                <i v-if="!item.path"
                   class="material-icons lp-menu-item-arrow">
                  keyboard_arrow_{{ item.selected ? 'up': 'down' }}</i>
              </a>
              <!-- 2차 -->
              <ul style="margin:0;padding-left:0">
                <li v-for="child in item.child" :key="child.id"
                    v-show="item.selected && visible(child)">
                  <a @click.capture.prevent="selectMenu(child)"
                     :style="menuColorStyle(child.child)"
                     :href="child.path"
                     :class="{'menu-selected':selection(child.path)}"
                     class="menu-hover depth2">
                    <div class="menu-name">{{ child.name }}</div>
                    <i v-if="!child.path"
                       class="material-icons lp-menu-item-arrow">
                      keyboard_arrow_{{ child.selected ? 'up': 'down' }}</i>
                  </a>
                  <!-- 3차 -->
                  <ul style="margin:0;padding:0">
                    <li v-for="gchild in child.child" :key="gchild.id"
                        v-show="child.selected && visible(gchild)">
                      <a :style="menuColorStyle(gchild.child)"
                         @click.capture.prevent="selectMenu(gchild)"
                         :href="gchild.path"
                         :class="{'menu-selected':selection(gchild.path)}"
                         class="menu-hover depth3">
                        <div class="menu-name">{{ gchild.name }}</div>
                      </a>
                      <!-- 4차 -->
                      <ul style="margin:0;padding:0">
                        <li v-show="gchild.selected"
                            v-for="ggchild in gchild.child" :key="ggchild.id">
                          <a style="color: #b6becb; position: relative;padding: 1em 1.75em 1em 5em"
                             :style="menuColorStyle(ggchild.child)"
                             @click.capture.prevent="selectMenu(ggchild)"
                             :href="ggchild.path"
                             :class="{'menu-selected':selection(ggchild.path)}"
                             class="menu-hover">
                            <div class="menu-name">{{ ggchild.name }}</div>
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
            <div class="bg-add-pack" v-if="cm.expand && (cm.market || cm.inquiry)">
              <button class="is-primary" @click="clickMarket(cm)">팩 {{ serviceInfo.service_type === 4 && cm.market ? '설치' : '문의' }}하기</button>
            </div>
          </div>
        </div>
      </ul>
    </aside>

    <!-- Guide -->
    <div class="guide" v-if="selectedGuide">
      <div class="modal-guide" v-if="v.modal">
        <div style="width:100%">
          <img :src="svgSrc(`symbol_${selectedGuide.pack}`)">
          <div class="subtitle4 main" style="margin-top:28px">{{ selectedGuide.title }}</div>
          <div class="body2 main" style="margin-top:8px">정상설치 되었습니다.</div>
          <button class="button is-primary" style="margin-top:40px;width:100%" @click="clickGuide">가이드 시작하기</button>
        </div>
      </div>
      <div class="modal-guide" key="modal-guide-end" v-if="step > selectedGuide.steps.length">
        <div style="width:100%">
          <div class="body4 sub3">{{ selectedGuide.sub }}</div>
          <img :src="svgSrc(`symbol_${selectedGuide.pack}`)" style="margin-top:30px">
          <div class="subtitle4 main" style="margin-top:20px">{{ selectedGuide.title }}<br/> 상품을 추가해보세요.</div>
          <div class="body5 sub2" style="margin-top:8px">추가적으로 궁금하신 사항은<br/> 1:1문의를 이용해주세요.</div>
          <div class="button-grid" style="margin-top: 40px; width: 100%">
            <button class="button is-primary-light" style="width: 100%; font-family:inherit" @click="closeGuide('reg')">
              상품 등록하기
            </button>
            <button class="button is-gray" style="width: 100%; font-family:inherit" @click="closeGuide('close')">나중에
              등록하기
            </button>
          </div>
        </div>
      </div>
      <div id="help-guide" v-if="v.help && step <= selectedGuide.steps.length">
        <div class="triangle"></div>
        <div class="body2-medium main">{{ selectedGuide.steps[step-1].title }}</div>
        <div class="body4 sub2" style="margin-top:6px">{{ selectedGuide.steps[step-1].desc }}</div>
        <div class="flex-between" style="margin-top:16px">
          <div class="flex-align">
            <div class="dot" :class="{'dot-step': step === idx}" v-for="idx in selectedGuide.steps.length"
                 :key="'dot-'+idx"></div>
          </div>
          <div class="flex-align">
            <div class="button-step unselect" v-if="step>1" @click="clickPrev">이전</div>
            <div class="button-step unselect" @click="clickNext">다음</div>
          </div>
        </div>
      </div>
    </div>

    <modal name="planGuideModal" :adaptive="true" :width="360" height="auto" :clickToClose="false" class="modal-style">
      <div class="lp-modal-wrapper flex-center" style="background-color:#e9e9e9;">
        <div>
          <div class="body1 weight-500 text-center" style="margin-bottom:12px">안내</div>
          <div class="body4 text-center" style="margin-bottom:16px">페이지 접속을 위해서는 <br>
            플랜 변경이 필요합니다.
          </div>
          <div class="flex-between">
            <button class="button is-sub4" style="width:100px;margin-right:6px" @click="$modal.hide('planGuideModal')">
              이전
            </button>
            <button class="button is-primary" style="width:150px" @click="clickPlanUpdate">플랜 변경하기</button>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
  import SidebarMixin from "@/mixins/SidebarMixin";

  const icon = {
    dashboard: {
      enabled: require('@/assets/image/menu/dashboard.png'),
      selected: require('@/assets/image/menu/dashboard_selected.png'),
    },
    service: {
      enabled: require('@/assets/image/menu/service.png'),
      selected: require('@/assets/image/menu/service_selected.png'),
    },
    user: {
      enabled: require('@/assets/image/menu/user.png'),
      selected: require('@/assets/image/menu/user_selected.png'),
    },
    partner: {
      enabled: require('@/assets/image/menu/partner.png'),
      selected: require('@/assets/image/menu/partner_selected.png'),
    },
    product: {
      enabled: require('@/assets/image/menu/product.png'),
      selected: require('@/assets/image/menu/product_selected.png'),
    },
    category_region: {
      enabled: require('@/assets/image/menu/category.png'),
      selected: require('@/assets/image/menu/category_selected.png'),
    },
    product_review_inquiry: {
      enabled: require('@/assets/image/menu/product.png'),
      selected: require('@/assets/image/menu/product_selected.png'),
    },
    cs: {
      enabled: require('@/assets/image/menu/cs.png'),
      selected: require('@/assets/image/menu/cs_selected.png'),
    },
    basic_board: {
      enabled: require('@/assets/image/menu/board.png'),
      selected: require('@/assets/image/menu/board_selected.png'),
    },
    board: {
      enabled: require('@/assets/image/menu/board.png'),
      selected: require('@/assets/image/menu/board_selected.png'),
    },
    exhibition: {
      enabled: require('@/assets/image/menu/banner.png'),
      selected: require('@/assets/image/menu/banner_selected.png'),
    },
    filter: {
      enabled: require('@/assets/image/menu/filter.png'),
      selected: require('@/assets/image/menu/filter_selected.png'),
    },
    ui: {
      enabled: require('@/assets/image/menu/design.png'),
      selected: require('@/assets/image/menu/design_selected.png'),
    },
    call: {
      enabled: require('@/assets/image/menu/call.png'),
      selected: require('@/assets/image/menu/call_selected.png'),
    },
    purchase: {
      enabled: require('@/assets/image/menu/purchase.png'),
      selected: require('@/assets/image/menu/purchase_selected.png'),
    },
    cancel_purchase: {
      enabled: require('@/assets/image/menu/purchase.png'),
      selected: require('@/assets/image/menu/purchase_selected.png'),
    },
    download: {
      enabled: require('@/assets/image/menu/purchase.png'),
      selected: require('@/assets/image/menu/purchase_selected.png'),
    },
    estimate: {
      enabled: require('@/assets/image/menu/estimate.png'),
      selected: require('@/assets/image/menu/estimate_selected.png'),
    },
    estimate_order: {
      enabled: require('@/assets/image/menu/estimate.png'),
      selected: require('@/assets/image/menu/estimate_selected.png'),
    },
    account: {
      enabled: require('@/assets/image/menu/account.png'),
      selected: require('@/assets/image/menu/account_selected.png'),
    }
  };

  export default {
    components: {},
    mixins: [
      SidebarMixin
    ],

    props: {
      show: Boolean
    },

    data() {
      return {
        excludePages: [
          'dashboard', 'service/plan', 'launchpack/inquiry/customer', 'launchpack/inquiry/customer/create'
        ],
        internalPlugin: undefined,
        // 커맨드 키 누른 여부
        clickCommand: false,
        to: undefined,
        // 가이드 관련
        v: {
          modal: true,
          help: false
        },
        step: 1,
        guide: [
          {
            pack: 'delivery',
            sub: '오픈마켓 등 다양한 비즈니스에 적용할 수 있는',
            title: '상품 택배 배송 팩',
            steps: [
              {
                title: '온라인 커머스에서 필요한 모든 운영/관리 플로우 제공',
                desc: '상품 구매는 물론, 플랫폼에서 결제만 이루어지면\n택배배송 조회 부터 교환, 반품, 정산까지 한번에 관리가 가능합니다! ',
                menu: {
                  depth: 1,
                  text: '상품 택배 배송'
                }
              },
              {
                title: '카테고리별 상품 종류(팩) 관리',
                desc: '팩별로 다른 카테고리에 등록해두거나, 동일 카테고리에 여러 종류의상품을 등록할 수 있습니다.',
                menu: {
                  depth: 3,
                  text: '카테고리 관리'
                }
              },
              {
                title: '상품 관리',
                desc: '상품을 등록, 삭제, 관리하고 상품별로 문의와 주문을 받는 방식을 선택할 수 있습니다.',
                menu: {
                  depth: 3,
                  text: '상품 관리'
                }
              }
            ],
          },
          {
            pack: 'reservation',
            sub: '비즈니스의 활용성이 가장 높은',
            title: '시간단위 서비스 예약팩',
            steps: [
              {
                title: '예약 서비스 맞춤 운영 관리 솔루션 제공',
                desc: '예약 외의 이용완료, 취소신청, 환불완료, 노쇼 등 예약 서비스에서 발생하는 모든 주문 상황에 대비할 수 있습니다.',
                menu: {
                  depth: 1,
                  text: '시간단위 서비스 예약'
                }
              },
              {
                title: '편리한 정산 관리',
                desc: '서비스 정책에 맞추어 사전에 정산 기준을 설정할 수 있을 뿐 아니라 정산 기준에 따라 계산된 파트너 정산 내역 확인까지 가능합니다!',
                menu: {
                  depth: 2,
                  text: '시간단위 예약 서비스 정산'
                }
              },
              {
                title: '카테고리별 상품 종류(팩) 관리',
                desc: '팩별로 다른 카테고리에 등록해두거나, 동일 카테고리에 여러 종류의상품을 등록할 수 있습니다.',
                menu: {
                  depth: 3,
                  text: '카테고리 관리'
                }
              },
              {
                title: '상품 관리',
                desc: '상품을 등록, 삭제, 관리하고 상품별로 문의와 주문을 받는 방식을 선택할 수 있습니다.',
                menu: {
                  depth: 3,
                  text: '상품 관리'
                }
              }
            ],
          },
          {
            pack: 'booking',
            sub: '비즈니스의 활용성이 가장 높은',
            title: '기간단위 서비스 예약팩',
            steps: [
              {
                title: '예약 서비스 맞춤 운영 관리 솔루션 제공',
                desc: '예약 외의 이용완료, 취소신청, 환불완료, 노쇼 등 예약 서비스에서 발생하는 모든 주문 상황에 대비할 수 있습니다.',
                menu: {
                  depth: 1,
                  text: '기간단위 서비스 예약'
                }
              },
              {
                title: '편리한 정산 관리',
                desc: '서비스 정책에 맞추어 사전에 정산 기준을 설정할 수 있을 뿐 아니라 정산 기준에 따라 계산된 파트너 정산 내역 확인까지 가능합니다!',
                menu: {
                  depth: 2,
                  text: '기간단위 예약 서비스 정산'
                }
              },
              {
                title: '카테고리별 상품 종류(팩) 관리',
                desc: '팩별로 다른 카테고리에 등록해두거나, 동일 카테고리에 여러 종류의상품을 등록할 수 있습니다.',
                menu: {
                  depth: 3,
                  text: '카테고리 관리'
                }
              },
              {
                title: '상품 관리',
                desc: '상품을 등록, 삭제, 관리하고 상품별로 문의와 주문을 받는 방식을 선택할 수 있습니다.',
                menu: {
                  depth: 3,
                  text: '상품 관리'
                }
              }
            ],
          }
        ],
        selectedGuide: undefined
      };
    },

    computed: {
      /*menus() {
        return this.$store.getters.menus;
      },*/
      isBuilder() {
        return this.$store.getters.fromBuilder;
      },
      serviceDomain() {
        return this.$store.getters.getServiceSetting.domain;
      },
      serviceName() {
        return this.$store.getters.serviceName;
      },

      showCircle() {
        return 'position: absolute;' +
          'left: 19px; font-size: 3rem;' +
          'top: -6px;';
      },
    },

    watch: {
      '$route.query.id'(n) {
        if (n) {
          //console.log('query',n)
          this.initSelection(this.menus);
          this.initComputed(this.computedMenu);
        }
      },
      '$store.getters.guide'(n) {
        if (n) {
          this.step = 1;
          this.v.modal = true;
          this.v.help = false;
          this.$root.$emit('menus');
          this.selectedGuide = this.guide.find(i => i.pack === n);
        }
      },
    },
    created() {
      window.addEventListener('keydown', this.keydownFunc);
      window.addEventListener('keyup', this.keyupFunc);
    },
    destroyed() {
      window.removeEventListener('keydown', this.keydownFunc);
      window.removeEventListener('keyup', this.keyupFunc);
    },

    methods: {
      unselectMenus(menus) {
        menus.forEach(i => {
          if(i.selected !== undefined) {
            i.selected = false;
          }
          if(i.child) {
            this.unselectMenus(i.child);
          }
          if(i.menu) {
            this.unselectMenus(i.menu);
          }
        });
      },
      selectLpMenu(menu) {
        this.dashboard.selected = false;
        this.unselectMenus(this.computedMenu);
        this.menu_set.lp_admin_menu.forEach(i => {
          i.selected = i.menu_id === menu.menu_id;
          if(i.child) {
            i.child.forEach(j => {
              j.selected = j.menu_id === menu.menu_id;
              if(j.selected) {
                i.selected = true;
              }
            });
          }
        });

        if(menu.path) {
          if (menu.path.indexOf('ui/builder') > -1) {
            window.open(menu.path, '_blank');
          } else if (menu.path === 'app_market') {
            this.$root.$emit('appMarket');
          } else {
            this.routerPush(this.getPath(menu.path));
          }
        }
        this.$forceUpdate();
      },
      hasImg(item) {
        return (item.img || item.icon) && this.src(item);
      },
      menuItemImg(item) {
        return item.img ? 'lp-menu-img' : item.icon ? 'lp-menu-icon' : '';
      },
      menuItemClass(item) {
        return `menu-item-${item.selected ? 'selected-' : ''}bg`;
      },
      clickPlanUpdate() {
        this.routerPush(this.getPath('service/plan'))
        this.$modal.hide('planGuideModal')
      },
      checkAvailableClick(path) {
        let enable = true;
        if (this.stopAdmin) enable = false;
        if (this.excludePages.indexOf(path) > -1) enable = true;
        return enable;
      },
      clickPrev() {
        this.step--;
        this.setColorInit();
        this.setScrollMenu();
      },
      clickNext() {
        this.step++;
        this.setColorInit();
        this.setScrollMenu();
      },
      setColorInit() {
        Object.keys(this.$refs).forEach(key => {
          for (let child of this.$refs[key][0].children) {
            child.children[0].style.backgroundColor = '#32373F';
            child.children[0].style.color = 'rgb(182, 190, 203)';

            if (child.children.length > 1 && child.children[1].children.length > 0) {
              for (let gc of child.children[1].children) {
                gc.children[0].style.backgroundColor = '#32373F';
                gc.children[0].style.color = 'rgb(182, 190, 203)';
              }
            }
          }
        })
      },
      setScrollMenu() {
        if (this.selectedGuide.steps.length < this.step || this.step < -1) return;
        let menu = this.selectedGuide.steps[this.step - 1].menu;

        // depth 1
        if (menu.depth === 1) {
          let index = this.computedMenu.findIndex(i => {
            return i.title === menu.text
          });
          let el = this.$refs[`item${index}`][0];
          let y = window.pageYOffset + el.getBoundingClientRect().y + document.getElementById('hideScroll').scrollTop - 300;
          document.getElementById('hideScroll').scrollTo(0, y);

          for (let child of el.children) {
            child.children[0].style.backgroundColor = '#ff5722';
            child.children[0].style.color = 'white';
          }

          setTimeout(() => {
            let top = el.getBoundingClientRect().y - 50;
            document.getElementById('help-guide').style.top = top + 'px';
          }, 300);
        }

        // depth 2
        else if (menu.depth === 2) {
          this.computedMenu.forEach((item, idx) => {
            let index = item.menu.findIndex(m => {
              return m.name === menu.text
            });
            if (index > -1) {
              let el = this.$refs[`item${idx}`][0].children[index];

              el.children[0].style.backgroundColor = '#ff5722';
              el.children[0].style.color = 'white';

              let y = window.pageYOffset + el.getBoundingClientRect().y - el.getBoundingClientRect().height + document.getElementById('hideScroll').scrollTop - 300;
              document.getElementById('hideScroll').scrollTo(0, y);

              //this.selectMenu(item.menu[index]);

              setTimeout(() => {
                let top = el.getBoundingClientRect().y - 60;
                document.getElementById('help-guide').style.top = top + 'px';
              }, 200);
            }
          })
        }
        // depth3
        else {
          let idx1 = -1;
          let idx2 = -1;
          let idx3 = -1;
          let selMenu = undefined;
          this.computedMenu.forEach((item, idx) => {
            item.menu.forEach((m, cidx) => {
              let childIndex = m.child ? m.child.findIndex(c => {
                return c.name === menu.text
              }) : -1;
              if (childIndex > -1) {
                idx1 = idx;
                idx2 = cidx;
                idx3 = childIndex;
                selMenu = m;
              }
            });
          });

          if (idx3 > -1) {
            this.selectMenu(selMenu);
            this.$nextTick(() => {
              setTimeout(() => {
                let el = this.$refs[`item${idx1}`][0].children[idx2];

                let y = window.pageYOffset + el.getBoundingClientRect().y + document.getElementById('hideScroll').scrollTop - 300;
                document.getElementById('hideScroll').scrollTo(0, y);

                setTimeout(() => {
                  let top = el.getBoundingClientRect().y;
                  document.getElementById('help-guide').style.top = top + 'px';

                  let sel = this.$refs[`item${idx1}`][0].children[idx2].children[1].children[idx3].children[0];
                  sel.style.backgroundColor = '#ff5722';
                  sel.style.color = 'white';
                });
              }, 200);
            })
          }
        }
      },
      clickGuide() {
        this.v.modal = false;
        this.v.help = true;
        this.setScrollMenu();
      },
      closeGuide(type) {
        this.selectedGuide = undefined;
        this.$store.commit('setGuide', '');
        this.$axios.patch('admin/service/setting', {'new_package': ''});
        if (type === 'reg') {
          this.routerPush('/office/admin/product/create');
        }
      },
      clickMarket(cm) {
        if (this.serviceInfo.service_type === 5 || cm.inquiry) {
          this.routerPush('/office/admin/launchpack/inquiry/customer/create?cat=7');
        } else if (cm.market) {
          this.$root.$emit('appMarket', {pack: cm.pack});
        }
      },
      openLink(type) {
        if (type === 1) {
          if (this.stopAdmin) return;
          //if (this.isInternalPlugin('builder')) {
          if(this.serviceInfo && this.serviceInfo.service_type === 4) {
            window.open('/developers/ui/builder', '_blank');
          } else {
            this.$root.$emit('builder');
          }
        } else {
          window.open(this.serviceDomain, '_blank');
        }
      },
      keydownFunc(e) {
        if (e.keyCode === 91 || e.keyCode === 17) {
          this.clickCommand = true;
          if (this.to) {
            clearTimeout(this.to);
          }
          this.to = setTimeout(() => {
            this.clickCommand = false;
            this.to = undefined;
          }, 500);
        }
        if (e.key === 's') {
          this.clickCommand = false;
        }
      },
      keyupFunc(e) {
        if (e.keyCode === 91 || e.keyCode === 17) {
          this.clickCommand = false;
        }
      },
      visible(item) {
        // 플러그인은 런치팩 관리자만 볼 수 있게함.
        if (['service.plugin', 'service.menu.admin_menu', 'ui.design'].indexOf(item.menu_id) > -1) {
          return this.isMasterAdmin;
        }
        if (item.menu_id === 'dashboard') {
          return false;
        }

        // enable이 있고 비활성화일 경우 false 처리
        if (Object.keys(item).indexOf('enable') > -1) {
          if (!item.enable) return false;
        }

        // 플러그인 체크
        if (item.plugin) {
          return this.isInternalPlugin(item.plugin)
        }

        // 거래타입이 설정된 메뉴일 때, 해당 거래타입에서만 노출
        if(item.ecommerce_type) {
          return this.$store.getters.getServiceSetting.ecommerce_type === item.ecommerce_type;
        }
        return true;
      },
      menuColorStyle(child) {
        // if (child.length===0) {
        //   return 'color:#667283';
        // }
      },

      /**
       * Get parent menu of the menu.
       */
      parentMenu(menu) {
        const route = menu.menu_id.split('.');
        if (route.length === 1) {
          return null;
        }
        let found = null;
        this.computedMenu.some(c_menu => {
          found = c_menu.menu.find(menu => menu.menu_id === route[0]);
          if (found) {
            for (let i = 1; i < route.length - 1; ++i) {
              found = found.child.find(menu => menu.menu_id.split('.').slice(-1)[0] === route[i]);
            }
            return found;
          }
        })
        return found;
      },
      selectMenu(menu) {
        this.unselectMenus(this.menu_set.lp_admin_menu);

        if(menu.menu_id === 'dashboard') {
          this.unselectMenus(this.computedMenu);
          this.dashboard.selected = true;
          this.routerPush(this.getPath(this.dashboard.path));
          return;
        }

        const parent = this.parentMenu(menu);
        // 한 종류의 메뉴만 활성화
        this.computedMenu.forEach(c_menu => {
          for (let i = 0; i < c_menu.menu.length; i++) {
            if (c_menu.menu[i].menu_id === menu.menu_id) {
              // console.log('선택된 메뉴', menu)
              menu.selected = !menu.selected;
              if (menu.selected) this.moveSelectedMenu();
            } else if (parent) { // parent 있을 경우 예외처리
              continue;
            } else {
              // console.log('선택되지 않은 메뉴', this.menus[i].menu_id)
              c_menu.menu[i].selected = false;
            }
          }
        })

        if (parent) {
          menu.selected = !menu.selected;
        }

        if (menu.child) {
          for (let k = 0; k < menu.child.length; k++) {
            if (menu.child[k].child && menu.child[k].child.length !== 0) {
              menu.child[k].selected = true;
              for (let l = 0; l < menu.child[k].child.length; l++) {
                if (menu.child[k].child[l].selected !== 0) {
                  menu.child[k].child[l].selected = true;
                }
              }
            }
          }
        }

        //menu.selected = !menu.selected;
        if (menu.path !== null && menu.path !== undefined) {
          // 페이지 디자인일 경우 새탭 예외처리
          if (menu.path.indexOf('ui/builder') > -1) {
            window.open(menu.path, '_blank');
          } else if (menu.path === 'app_market') {
            this.$root.$emit('appMarket');
          }
          // command 누르고 메뉴 선택했을 경우
          else if (this.clickCommand) {
            console.log(this.clickCommand);
            let path = this.getPath(menu.path)
            window.open(path, '_blank');
          } else {
            let path = this.getPath(menu.path)
            if (this.checkAvailableClick(menu.path)) {
              this.routerPush(path);
            } else {
              // 페이지 변경을 위해서는 플랜 변경 필요 팝업
              this.$modal.show('planGuideModal');
            }
          }
          // 모바일일 경우 메뉴 선택시 메뉴창 닫기
          if (this.$store.getters.device === 'mobile') {
            this.$store.commit('setSideBar', false);
          }
        }
      },
      selection(path) {
        this.initSelection(this.menus);
        if (path) {
          path = this.changePath(path);
        }
        // console.log('현재페이지 라우팅된거 : ' + this.changePath(this.$route.path));
        // console.log('클릭 : ' + path);
        if (path === this.changePath(this.$route.path)) {
          if (this.$route.query.id) {
            return false;
          } else {
            return true;
          }
        } else return false;
      },
      // 선택된 메뉴 false로 초기화
      initSelection(menus) {
        for (let i = 0; i < menus.length; i++) {
          if (menus[i].path) {
            menus[i].selected = false;
          }
          if (menus[i].child) {
            this.initSelection(menus[i].child)
          }
        }
      },
      // 선택된 computedMenu false로 초기화
      initComputed(menus) {
        for (let i = 0; i < menus.length; i++) {
          // if(menus[i].hasOwnProperty('selected')) {
          //     menus[i].selected = false;
          //   }
          if (menus[i].menu && menus[i].menu.length > 0) {
            this.initComputed(menus[i].menu);
          }
          if (menus[i].child && menus[i].child.length > 0) {
            for (let j = 0; j < menus[i].child.length; j++) {
              if (menus[i].child[j].child && menus[i].child[j].child.length > 0) {
                menus[i].child[j].child.forEach(item => {
                  item.selected = false;
                })
              } else {
                menus[i].child[j].selected = false;
              }
            }
          }
        }
      },
      // UI 설정 메뉴 추가
      addUiMenu() {
        //window.location.href
        let path = `https://${window.location.host}/ui/admin/pagedesign`;
        let ui = {
          'menu_id': 'ui',
          'name': 'UI 설정 메뉴',
          'img': 'https://s3.ap-northeast-2.amazonaws.com/launchpack-storage/media/admin/menu/design.png',
          'selected': false,
          'child': [
            {
              'menu_id': 'ui.page_design',
              'name': '디자인 편집',
              'path': path,
              'child': [],
              'selected': false
            }
          ]
        }
        return ui;
      },

      src(menu) {
        if (menu.img) {
          if (!icon[menu.menu_id]) {
            return null;
          }
          return (menu.selected) ? icon[menu.menu_id].selected : icon[menu.menu_id].enabled;
        } else {
          if (this.isLaunchpack) {
            return `/static/icon/${menu.icon}.svg`;
          } else if (process.env.NODE_ENV === 'production') {
            return `/office/static/icon/${menu.icon}.svg`;
          } else return `/static/icon/${menu.icon}.svg`;
        }
      }
    },

  }
</script>

<style lang="scss" scoped>
  @import '~bulma/sass/utilities/mixins';

  button.is-primary {
    background-color: #ff5722;
    border-radius: 4px;
    padding: 6px 12px;
    color: white;
    font-size: 12px;
    font-weight: 700;
    border: 0;
    cursor: pointer;
  }

  button.is-primary:hover {
    background-color: #ff5722;
  }

  .button-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 0 16px;
  }

  .bg-add-pack {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(70, 70, 70, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  #hideScroll::-webkit-scrollbar {
    display: none;
  }

  .svg-white {
    filter: invert(89%) sepia(100%) saturate(36%) hue-rotate(192deg) brightness(200%) contrast(99%);
  }

  .lp-menu-img {
    width: 15px;
    height: 15px;
  }

  .lp-menu-icon, .svg-primary {
    width: 18px;
    height: 18px;
  }

  .lp-menu-item {
    .lp-menu-child {
      padding: 16px 20px;
      padding-right: 12px;
      cursor: pointer;
    }
  }

  .menu-hover:hover {
    background-color: #ff5722 !important;
    color: #fff !important;
    .lp-menu-item-arrow {
      color: #AEAEAE !important;
    }
  }

  .lp-menu-item {
    color: white;
    border-top: 1px solid white;
    background-color: #777;
  }

  .lp-menu-child {
    background-color: white;
    color: #777;
    padding-left: 28px;
  }

  .lp-menu-child:last-child {
    border-bottom: 0;
  }

  .lp-menu-child:hover {
    background-color: #ff5722;
    color: #fff !important;
  }

  .menu-selected {
    background-color: #ff5722;
    color: #fff !important;
    width: 100%;
    /*top: 0;
    left: 0;
    width: 8px;
    height: 45px;*/
  }

  /*.selected-depth {
    color: #fff
  }*/

  .app-sidebar {
    position: fixed;
    left: 0;
    bottom: 0;
    padding: 0 0 50px;
    width: 230px;
    min-width: 40px;
    max-height: 100vh;
    z-index: 1024 - 1;
    background: #32373F;
    box-shadow: 0 2px 3px rgba(17, 17, 17, 0.1), 0 0 0 1px rgba(17, 17, 17, 0.1);
    overflow-y: auto;
    overflow-x: hidden;

    @include mobile() {
      transform: translate3d(-180px, 0, 0);
    }

    .icon {
      vertical-align: baseline;

      &.is-angle {
        position: absolute;
        right: 10px;
        transition: transform .377s ease;
      }
    }

    .menu-label {
      padding-left: 5px;
    }

    .menu-list {
      padding-top: 12px;

      li a {
        &[aria-expanded="true"] {
          .is-angle {
            transform: rotate(180deg);
          }
        }
      }

      li a + ul {
        margin: 0 10px 0 15px;
      }

      ul {
        border-left: 0;
      }
    }

    .menu-item-selected-bg {
      background-color: #32373F;
      .menu-name, .lp-menu-item-arrow {
        color: #ff5722;
      }
      .lp-menu-icon {
        filter: invert(54%) sepia(46%) saturate(5884%) hue-rotate(360deg) brightness(100%) contrast(110%);
      }
    }

    .menu-item-selected-bg:hover {
      background-color: #ff5722;
      .menu-name {
        color: #ffffff !important;
      }
      .lp-menu-item-arrow {
        color: #AEAEAE !important;
      }
      .lp-menu-icon {
        filter: invert(89%) sepia(100%) saturate(36%) hue-rotate(192deg) brightness(200%) contrast(99%) !important;
      }
    }

    .menu-item-bg {
      background-color: #32373F;
    }

    .menu-item-bg:hover {
      background-color: #ff5722 !important;
      .menu-name {
        color: #ffffff !important;
      }
      .lp-menu-item-arrow {
        color: #AEAEAE !important;
      }

      .lp-menu-icon {
        filter: invert(89%) sepia(100%) saturate(36%) hue-rotate(192deg) brightness(200%) contrast(99%) !important;
      }
    }

    .menu-item, .depth2, .depth3 {
      position: relative;
      height: 35px;
      display: flex;
      align-items: center;
      gap: 0 12px;
      font-size: 13px;
      color: white;
    }

    .menu-item {
      padding: 8px 12px;
    }

    .lp-menu-item-arrow {
      color: #aeaeae;
      font-size: 13px;
    }

    .depth2 {
      padding: 8px 12px 8px 40px;
    }

    .depth3 {
      padding: 8px 12px 8px 52px;
      color: #989898;
    }

    .menu-name {
      flex: 1;
    }

    .menu-selected
    .depth2 {
      color: #b6becb;
      position: relative;
    }

    .menu-title-wrapper {
      margin-top: 8px;
      padding: 12px;
      padding-bottom: 6px;
      display: flex;
      align-items: center;
      .menu-title {
        color: #989898;
        font-size: 12px;
        font-weight: 700;
        padding-right: 10px;
      }
      .menu-title-solid {
        flex: 1;
        height: 1px;
        background-color: #aeaeae;
      }
    }
    .menu-title-foldable-wrapper {
      margin-top: 8px;
      padding: 12px;
      padding-bottom: 6px;
      display: flex;
      align-items: center;
      color: #ffffff;

      .menu-title {
        font-size: 12px;
        font-weight: 700;
        padding: 0 10px 0 8px;
      }
      .menu-title-solid {
        flex: 1;
        height: 1px;
        background-color: #ffffff;
      }
      .menu-arrow {
        margin-left: 12px;
        font-size: 13px;
      }
    }
  }

  .guide {
    position: fixed;
    width: 100%;
    left: 230px;
    top: 50px;
    background-color: rgba(0, 0, 0, 0.6);
    height: 100%;
    z-index: 10;
  }

  .modal-guide {
    position: fixed;
    top: calc(50% - 188px);
    left: calc(50% - 200px);
    background-color: white;
    border-radius: 8px;
    width: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 64px;

    button {
      height: 40px !important;
      border-radius: 8px;
    }
  }

  #help-guide {
    position: fixed;
    top: calc(50% - 188px);
    left: 264px;
    background-color: white;
    border-radius: 8px;
    width: 400px;
    padding: 16px 24px;

    .triangle {
      width: 16px;
      height: 16px;
      transform: rotate(45deg);
      position: absolute;
      left: -8px;
      top: calc(50% - 10px);
      background: white;
    }

    .dot {
      width: 7px;
      height: 7px;
      border-radius: 100%;
      background-color: #FFDBC1;
      margin-right: 10px;
    }

    .dot:last-child {
      margin-right: 0;
    }

    .dot-step {
      background-color: #ff5722;
    }

    .button-step {
      color: #ff5722;
      margin-left: 32px;
    }

    .button-step:first-child {
      margin-left: 0;
    }
  }

  .button-site-wrapper {
    background-color: #242629;
    padding: 12px 10px;
  }
  .button-site {
    width: 100%;
    padding: 6px 16px;
    gap: 8px;
    display: flex;
    align-items: center;
    font-size: 13px;
    color: #242629;
    background-color: white;
    border-radius: 4px;
  }

  .menu-list a {
    border-radius: 0;
  }

  .button-site img {
    width: 14px;
    height: 14px;
  }

  .button-site:hover {
    background-color: #f5f5f5;
  }

  .button-site-primary {
    width: 100%;
    padding: 6px 16px;
    gap: 8px;
    display: flex;
    align-items: center;
    font-size: 13px;
    color: #ff5722;
    background-color: #FFF0EB;
    border-radius: 4px;
    margin-top: 6px;
  }

  .button-site-primary:hover {
    background-color: #FFEAD2;
  }

  .button-site-primary img {
    width: 14px;
    height: 14px;
  }

  .tag-trial {
    margin-left: 4px;
    background-color: #7B61FF;
    color: white;
    padding: 1px 4px;
    border-radius: 2px;
    font-size: 11px;
  }
</style>
